import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicSearch from "@/pages/PublicSearch";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import DiplomasActivos from "@/pages/DiplomasActivos";
import ActivadoresLanding from "@/pages/ActivadoresLanding";
import Contacto from "@/pages/Contacto";
import NotFound from "@/pages/NotFound";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center text-zinc-500 font-mono">
        Cargando…
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen bg-zinc-950">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<DiplomasActivos />} />
            <Route path="/activadores" element={<ActivadoresLanding />} />
            <Route path="/descarga" element={<PublicSearch />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
